export default __webpack_public_path__ + "static/media/Old_devor_kond1.619ac7c2.png";